const RecaudosReg = [
    {
        id: 0,
        recaudo: "A continuación haz click en el botón para descargar el instructivo"
    }
]

export default RecaudosReg;


// WEBPACK FOOTER //
// ./src/shared/RecaudosReg.jsx